import React from "react";
import { Link } from "react-router-dom";

const Pagination = ({ totalPages, currentPage, handlePageChange }) => {
  return (
    <ul className="pagination flex-center flex-wrap gap-16">
      {/* Previous Button */}
      <li className="page-item">
        <Link
          className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
          to="#"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <i className="ph-bold ph-arrow-left" />
        </Link>
      </li>

      {/* Page Number Links */}
      {[...Array(totalPages)].map((_, index) => {
        const pageNumber = index + 1;
        return (
          <li key={pageNumber} className="page-item">
            <Link
              className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 ${
                currentPage === pageNumber ? "active" : ""
              }`}
              to="#"
              onClick={() => handlePageChange(pageNumber)}
            >
              {String(pageNumber).padStart(2, "0")}
            </Link>
          </li>
        );
      })}

      {/* Next Button */}
      <li className="page-item">
        <Link
          className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
          to="#"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          <i className="ph-bold ph-arrow-right" />
        </Link>
      </li>
    </ul>
  );
};

export default Pagination;
